'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var _require = require('./baseEntity'),
    BaseEntity = _require.BaseEntity;

var _require2 = require('../resource'),
    OrganisationseinheitResource = _require2.OrganisationseinheitResource;

module.exports.Organisationseinheit = function (_BaseEntity) {
  _inherits(Organisationseinheit, _BaseEntity);

  _createClass(Organisationseinheit, null, [{
    key: '__name__',
    value: function __name__() {
      return 'organisationseinheit';
    }
  }]);

  function Organisationseinheit(data) {
    _classCallCheck(this, Organisationseinheit);

    var _this = _possibleConstructorReturn(this, (Organisationseinheit.__proto__ || Object.getPrototypeOf(Organisationseinheit)).call(this));

    _this._entityName = 'de.ul.fob.domain.Organisationseinheit';
    _this.beginn = null;
    _this.ende = null;
    _this.beschreibungDE = null;
    _this.beschreibungEN = null;
    _this.kostenstelle = null;
    _this.kostenstellenpfad = null;
    _this.name = null;
    _this.obsolet = false;
    _this.parentOrgaName = null;
    _this.inPubfob = null;

    _this.orgaIdent = null;
    _this.ueberOrganisationseinheit = null;
    _this.unterOrganisationseinheiten = null;
    _get(Organisationseinheit.prototype.__proto__ || Object.getPrototypeOf(Organisationseinheit.prototype), 'init', _this).call(_this, data);
    return _this;
  }

  _createClass(Organisationseinheit, [{
    key: 'toPostData',
    value: function toPostData() {
      return this.genericJSON({
        fields: ['_id', 'beginn', 'ende', 'beschreibungDE', 'beschreibungEN', 'kostenstelle', 'kostenstellenpfad', 'name', 'obsolet', 'parentOrgaName', 'inPubfob'],
        links: ['orgaIdent', 'ueberOrganisationseinheit', 'unterOrganisationseinheiten']
      });
    }
  }, {
    key: 'fetchOrgaIdent',
    value: function fetchOrgaIdent() {
      return _get(Organisationseinheit.prototype.__proto__ || Object.getPrototypeOf(Organisationseinheit.prototype), 'genericResolve', this).call(this, 'orgaIdent');
    }
  }, {
    key: 'fetchUeberOrganisationseinheit',
    value: function fetchUeberOrganisationseinheit() {
      return _get(Organisationseinheit.prototype.__proto__ || Object.getPrototypeOf(Organisationseinheit.prototype), 'genericResolve', this).call(this, 'ueberOrganisationseinheit');
    }
  }, {
    key: 'fetchUnterOrganisationseinheiten',
    value: function fetchUnterOrganisationseinheiten() {
      return _get(Organisationseinheit.prototype.__proto__ || Object.getPrototypeOf(Organisationseinheit.prototype), 'genericResolve', this).call(this, 'unterOrganisationseinheiten');
    }
  }, {
    key: 'fetchAll',
    value: function fetchAll() {
      return Promise.all([_get(Organisationseinheit.prototype.__proto__ || Object.getPrototypeOf(Organisationseinheit.prototype), 'genericResolve', this).call(this, 'orgaIdent'), _get(Organisationseinheit.prototype.__proto__ || Object.getPrototypeOf(Organisationseinheit.prototype), 'genericResolve', this).call(this, 'ueberOrganisationseinheit'), _get(Organisationseinheit.prototype.__proto__ || Object.getPrototypeOf(Organisationseinheit.prototype), 'genericResolve', this).call(this, 'unterOrganisationseinheiten')]);
    }
  }, {
    key: 'fetchResource',
    value: function fetchResource() {
      if (typeof OrganisationseinheitResource === 'undefined') {
        return this.fetchAll();
      } else {
        return _get(Organisationseinheit.prototype.__proto__ || Object.getPrototypeOf(Organisationseinheit.prototype), 'fetchQuery', this).call(this, OrganisationseinheitResource);
      }
    }
  }]);

  return Organisationseinheit;
}(BaseEntity);


//////////////////
// WEBPACK FOOTER
// ./~/fobclient/lib/entity/organisationseinheit.js
// module id = sCdg
// module chunks = 0